<template>
  <oie-my-pages-template v-if="hasCurrentMachineOwner" :title="currentMachineOwner.name" :with-go-back="true">
    <oie-accordion-tabs ref="tabs">
      <oie-accordion-tab name="machine-owner-information" display-name="Information">
        <oie-edit-wrapper>
          <template #preview-content>
            <oie-machine-owner-information :machine-owner="currentMachineOwner"></oie-machine-owner-information>
          </template>
          <template #edit-content="{ toggle }">
            <oie-add-edit-machine-owner-form
              :with-delete="true"
              @cancel="toggle"
              @save="handleSave($event, toggle)"
              @delete="handleDelete"></oie-add-edit-machine-owner-form>
          </template>
        </oie-edit-wrapper>
      </oie-accordion-tab>
      <oie-accordion-tab name="machine-owner-machines" :display-name="tStatic('machineOwnerMachines')">
        <oie-action-wrapper>
          <oie-base-action v-tooltip.top="tStatic('newMachineTooltip')" theme="flat" @click="handleAddMachine">
            <template #iconPrepend>
              <oie-base-icon icon="machine" size="s"></oie-base-icon>
            </template>
            {{ tStatic('newMachine') }}
          </oie-base-action>
        </oie-action-wrapper>
        <oie-my-machines-list-wrapper v-if="currentMachineOwner">
          <li v-for="machine in currentMachineOwner.machines" :key="`machine-${machine.machineId}`">
            <oie-machine-item :machine="machine" @select-machine="handleSelectMachine"></oie-machine-item>
          </li>
        </oie-my-machines-list-wrapper>
      </oie-accordion-tab>
      <oie-accordion-tab name="machine-owner-order-history" :display-name="tStatic('machineOwnerOrderHistory')">
        <oie-my-machines-order-history :id="{ownerId: currentMachineOwner.machineOwnerId}"></oie-my-machines-order-history>
      </oie-accordion-tab>

      <oie-accordion-tab name="machine-owner-invoice-history" lazy :display-name="tStatic('machineOwnerInvoiceHistory')">
        <oie-my-machines-invoice-history :id="{ownerId: currentMachineOwner.machineOwnerId}"></oie-my-machines-invoice-history>
      </oie-accordion-tab>

      <oie-accordion-tab name="machine-owner-connected-shoppinglists" :display-name="tStatic('machineOwnerConnectedShoppingLists')">
        <oie-my-machines-connected-shoppinglists :id="{ownerId: currentMachineOwner.machineOwnerId}"></oie-my-machines-connected-shoppinglists>
      </oie-accordion-tab>
    </oie-accordion-tabs>
  </oie-my-pages-template>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import myPages from '@/mixins/my-pages'
import tabs from '@/mixins/tabs'

export default {
  mixins: [myPages, tabs],
  provide() {
    return {
      context: { machineOwnerId: this.currentMachineOwner.machineOwnerId }
    }
  },
  computed: {
    ...mapGetters('myMachines', ['currentMachineOwner', 'hasCurrentMachineOwner'])
  },
  mounted() {
    this.rememberTab(`machine-owner-${this.currentMachineOwner.machineOwnerId}-details-tab`)
  },
  methods: {
    ...mapActions('myMachines', ['setCurrentMachineOwner', 'setCurrentMachine', 'deleteMachineOwner']),
    handleSave($event, toggle) {
      this.setCurrentMachineOwner($event)
      toggle()
    },
    handleAddMachine() {
      this.setCurrentMachine({ machineOwnerId: this.currentMachineOwner.machineOwnerId })
      this.goToSubPage(this.navigationOptions.oieAddOrEditMachine)
    },
    handleDelete() {
      this.publish('modal.show.generic', {
        header: `${this.tStatic('deleteMachineOrOwnerModalHeader')}: ${this.currentMachineOwner.name}`,
        text: this.tStatic('deleteMachineOrOwnerModalText'),
        buttons: [ {
          text: this.tStatic('genericDelete'),
          usePrimaryButton: true,
          handler: async () => {
            await this.deleteMachineOwner(this.currentMachineOwner)
            this.goToSubPage(this.navigationOptions.oieMyMachines)
            this.publish('modal.hide.generic')
          }
        }]
      })
    },
    handleSelectMachine(machine) {
      this.setCurrentMachine(machine)
      this.goToSubPage(this.navigationOptions.oieMachineDetails)
    }
  }
}
</script>

<style lang="scss">

</style>
